import {
    GroupToPrefixMap,
    RouteProperty,
    SearchRoutePrefix,
    TypeToRoutePropertyMap
} from "@/utils/search/routing/types/route.types";
import { getComponentGroup } from "@/utils/search/type.utils";
import {
    SearchComponentEnum,
    SearchComponentGroup,
    SearchComponentType
} from "@/utils/search/types/searchComponent";

export const getSearchComponentGroup = (prefix: SearchRoutePrefix) =>
    Object.entries(GroupToPrefixMap)
        .find(([_, prefixValue]) => prefixValue === prefix)
        ?.at(0) as SearchComponentGroup | undefined;

export const getSearchComponentTypeForRouteValue = (
    routeValue: RouteProperty | string
) =>
    (Object.entries(TypeToRoutePropertyMap)
        .find(([_, routeProperties]) =>
            (routeProperties as readonly string[]).find(
                (property) => property === routeValue
            )
        )
        ?.at(0) ?? "FACETS") as SearchComponentType;

export const getRoutePrefix = (component: SearchComponentEnum) => {
    const group = getComponentGroup(component);
    return group ? GroupToPrefixMap[group] : "";
};
